import React, { useState, useContext, useEffect } from "react";
import AdminTopBar from "../Common/AdminTopBar";
import InterfaceMenu from "../Interfaces/InterfaceMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api_handler } from "../../services/api";
import {
  faLock,
  faSave,
  faEye,
  faKey,
  faCertificate
} from "@fortawesome/free-solid-svg-icons";

import {
  GlobalStateContext,
  GlobalDispatchContext,
} from "../../state/GlobalContextProvider";

const Security = ({ interface_id }) => {
  const themeState = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const [orgCertificates, setOrgCertificates] = useState([]);
  const [otpSB, setOtpSB] = useState("");
  const [otpPROD, setOtpPROD] = useState("");
  const [currentSBCertificate, setCurrentSBCertificate] = useState("");
  const [currentPRODCertificate, setCurrentPRODCertificate] = useState("");
  const [apiSBKey, setApiSBKey] = useState("");
  const [apiPRODKey, setApiPRODKey] = useState("");
  const [isSBKeyVisable, setIsSBKeyVisable] = useState(false);
  const [isPRODKeyVisable, setIsPRODKeyVisable] = useState(false);

  useEffect(() => {
    const getCerts = async () => {
      var data = {};
      const api_rsp = await api_handler("org-cert:list", data, "POST");
      setOrgCertificates(api_rsp.data);
    };

    const getInterface = async () => {
      var data = {
        interface_id: interface_id,
      };
      const api_rsp = await api_handler("int:view", data, "POST");
      setCurrentSBCertificate(api_rsp.data.certificates.sandbox.certificate_id);
      setCurrentPRODCertificate(api_rsp.data.certificates.production.certificate_id);
    };

    getCerts();
    getInterface();
  }, [interface_id]);

  const handleSBOTP = (event) => {
    setOtpSB(event.target.value);
  };
  
  const handlePRODOTP = (event) => {
    setOtpPROD(event.target.value);
  };



  const changePRODSelectedValue = (event) => {
    setCurrentPRODCertificate(event.target.value);
  };

  const changeSBSelectedValue = (event) => {
    setCurrentSBCertificate(event.target.value);
  };

  const saveInterfaceCert = async (env) => {
    var data = {
      interface_id: interface_id,
      certificate_id: (env==='SB')?currentSBCertificate:currentPRODCertificate,
      environment: (env==='SB')?"sandbox":"production",
    };
    const api_rsp = await api_handler("int-cert:update", data, "POST");
    if (api_rsp.code === 200) {
      dispatch({ type: "TRIGGER_TOAST" });
    }
  };

  const viewInterfaceAPIKey = async (env) => {
    var data = {
      interface_id: interface_id,
      otp: (env==='SB')?otpSB:otpPROD,
      environment: (env==='SB')?"sandbox":"production",
    };
    const api_rsp = await api_handler("int-key:view", data, "POST");

    if(env==='SB'){
      setApiSBKey(api_rsp.data.apikey); setIsSBKeyVisable(true);
    } else {
      setApiPRODKey(api_rsp.data.apikey); setIsPRODKeyVisable(true);
    }
    setOtpSB("");
    setOtpPROD("");
   
    setTimeout(() => {
      setIsSBKeyVisable(false);
      setIsPRODKeyVisable(false);
    }, 15000);
  };

  return (
    <div>
      <AdminTopBar />
      <div className="section__master">
        <div className="grid grid-cols-12 gap-6">
 
          <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
            <div className="Section__body">
              <div className="intro-y box">
                <div className="flex items-center  pt-0 border-b border-gray-200">
                  <h2 className="font-medium text-base mr-auto">
                    <i className="">
                      <FontAwesomeIcon icon={faLock} />
                    </i>{" "}
                    &nbsp;&nbsp;Interface Security
                  </h2>
                </div>
                <p>
                  Tell.connect integrates with your application for
                  Authorisation (approving user consents) and access to
                  Resources (account information & payments). See The User Guide
                  for more information. Please provide the location for these
                  services on your application. You can edit these at any time.
                </p>

                <div className="p-lg-5">
                  <div className="intro-y box">
                    <div className="intro-y box ">
                    <div className="flex items-center  pt-0 border-b border-gray-200 ">
                        <h2 className="font-medium text-base mr-auto">
                          <i className="">
                            <FontAwesomeIcon icon={faKey} />
                          </i>{" "}
                          &nbsp;&nbsp;Environment API Keys
                        </h2>
                      </div>
                      <div className={"card card-form " + themeState.theme}>
                        <div className="row no-gutters">
                          
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">
                                Sandbox API Key Details
                              </strong>
                            </p>
                            <p className="upl_txt">
                              Messages from tell.connect will always include an
                              API Key in the Header
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body align-items-center">
                            <div className="form-group mt-3">
                              <label htmlFor="sandboxAuthUrl" for="exampleInputPassword1">
                                Enter OTP :
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="sandboxAuthUrl"
                                id="sandboxAuthUrl"
                                value={otpSB}
                                placeholder="Your secure OTP"
                                onChange={(event) => { handleSBOTP(event)}}
                              />
                            </div>
                            <div className="form-group mt-3">
                              <label  htmlFor="sandboxAuthUrl2" for="exampleInputPassword1">
                                API Key :
                              </label>

                              <input
                                disabled={true}
                                className="form-control appear-text-input"
                                type={isSBKeyVisable ? "text" : "password"}
                                name="sandboxAuthUrl"
                                id="sandboxAuthUrl2"
                                value={apiSBKey}
                                placeholder="###################"
                              />
                            </div>
                            <div className="text-left mt-3">
                              <button
                                className="cca-btn"
                                id="login_button"
                                type="button"
                                onClick={() => {viewInterfaceAPIKey("SB")}}
                              >
                                <div>
                                  VIEW<span></span>
                                  <i className="sbmt_but_icon">
                                    <FontAwesomeIcon icon={faEye} />
                                  </i>
                                </div>
                                <span></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={"card card-form mt-3 " + themeState.theme}
                      >
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">
                                Production API Key Details
                              </strong>
                            </p>
                            <p className="upl_txt">
                              Messages from tell.connect will always include an
                              API Key in the Header
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body align-items-center">
                            <div className="form-group mt-3">
                              <label  htmlFor="sandboxAuthUrl3" for="exampleInputPassword1">
                                Enter OTP :
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="sandboxAuthUrl"
                                id="sandboxAuthUrl3"
                                value={otpPROD}
                                placeholder="Your secure OTP"
                                onChange={(event) =>{handlePRODOTP(event)}}
                              />
                            </div>
                            <div className="form-group mt-3">
                              <label  htmlFor="sandboxAuthUrl4" for="exampleInputPassword1">
                                API Key :
                              </label>

                              <input
                                disabled={true}
                                className="form-control appear-text-input"
                                type={isPRODKeyVisable ? "text" : "password"}
                                name="sandboxAuthUrl"
                                id="sandboxAuthUrl4"
                                value={apiPRODKey}
                                placeholder="###################"
                              />
                            </div>
                            <div className="text-left mt-3">
                              <button
                                className="cca-btn"
                                id="login_button"
                                type="button"
                                onClick={() => {viewInterfaceAPIKey("PROD")}}
                              >
                                <div>
                                  VIEW<span></span>
                                  <i className="sbmt_but_icon">
                                    <FontAwesomeIcon icon={faEye} />
                                  </i>
                                </div>
                                <span></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center  pt-0 border-b border-gray-200 mt-3">
                        <h2 className="font-medium text-base mr-auto">
                          <i className="">
                            <FontAwesomeIcon icon={faCertificate} />
                          </i>{" "}
                          &nbsp;&nbsp;Environment Certificates
                        </h2>
                      </div>
                      <div
                        className={"card card-form mt-3 " + themeState.theme}
                       >
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">
                                Sandbox Certificate
                              </strong>
                            </p>
                            <p className="upl_txt">
                              If you assign a Certificate to your Interface, we
                              will also sign messages with a JWT utilising that
                              certificate.
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body">
                            <form>
                              <div className="form-group mt-5" data-select2-id="39">
                                <label  htmlFor="sandboxAuthUrl5" for="select01">
                                  Select Interface Certificate {currentSBCertificate}
                                </label>
                                <select
                                  id="sandboxAuthUrl5"
                                  data-toggle="select"
                                  className="form-control "
                                  onChange={(event)=> {changeSBSelectedValue(event)}}
                                  data-select2-id="select01"
                                  tabindex="-1"
                                  aria-hidden="true"
                                  onBlur={(event)=> {changeSBSelectedValue(event)}}
                                >
                                  <option selected="" data-select2-id="2">
                                    -- select certificate --
                                  </option>
                                  {orgCertificates.map((orgCert, index) => (
                                    <option
                                      selected={
                                        currentSBCertificate ===
                                        orgCert.certificate_id
                                          ? true
                                          : false
                                      }
                                      value={orgCert.certificate_id}
                                    >
                                      {orgCert.cert_name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="text-left mt-3">
                                <button
                                  className="cca-btn"
                                  id="login_button"
                                  type="button"
                                  onClick={()=>{saveInterfaceCert('SB')}}
                                >
                                  <div>
                                    Save<span></span>
                                    <i className="sbmt_but_icon">
                                      <FontAwesomeIcon icon={faSave} />
                                    </i>
                                  </div>
                                  <span></span>
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div
                        className={"card card-form mt-3 " + themeState.theme}
                       >
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">
                                Production Certificate {currentPRODCertificate}
                              </strong>
                            </p>
                            <p className="upl_txt">
                              If you assign a Certificate to your Interface, we
                              will also sign messages with a JWT utilising that
                              certificate.
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body">
                            <form>
                              <div className="form-group mt-5" data-select2-id="39">
                                <label  htmlFor="sandboxAuthUrl6" for="select01">
                                  Select Interface Certificate
                                </label>
                                <select
                                  id="sandboxAuthUrl6"
                                  data-toggle="select"
                                  className="form-control "
                                  onChange={(event)=>{changePRODSelectedValue(event)}}
                                  data-select2-id="select01"
                                  tabindex="-1"
                                  aria-hidden="true"
                                  onBlur={(event)=> {changePRODSelectedValue(event)}}
                                >
                                  <option selected="" data-select2-id="2">
                                    -- select certificate --
                                  </option>
                                  {orgCertificates.map((orgCert, index) => (
                                    <option
                                      selected={
                                        currentPRODCertificate ===
                                        orgCert.certificate_id
                                          ? true
                                          : false
                                      }
                                      value={orgCert.certificate_id}
                                    >
                                      {orgCert.cert_name} -  {currentPRODCertificate} - {orgCert.certificate_id}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="text-left mt-3">
                                <button
                                  className="cca-btn"
                                  id="login_button"
                                  type="button"
                                  onClick={()=>{saveInterfaceCert('PROD')}}
                                >
                                  <div>
                                    Save<span></span>
                                    <i className="sbmt_but_icon">
                                      <FontAwesomeIcon icon={faSave} />
                                    </i>
                                  </div>
                                  <span></span>
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
